import React, { useState, useEffect } from 'react';
import { postRequest, patchRequest } from '../../../../utils/httpRequest';
import { t } from "../../../../utils/i18n";

const ReviewForm = ({ profileId,reviewedProfileId, tradeExternalId, onSuccess, initialReview }) => {
  const [vote, setVote] = useState(initialReview?.vote || '');
  const [comment, setComment] = useState(initialReview?.comment || '');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (initialReview) {
      setVote(initialReview.vote || '');
      setComment(initialReview.comment || '');
    }
  }, [initialReview]);

  const handleVoteChange = (newVote) => {
    setVote(newVote);
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null)

    if (!vote || !comment || comment.trim().length===0 ) {
      setError(t("p2p.review.fill_all"));
      return;
    }

    if (!/^[a-zA-Z0-9\s.,'\n]*$/.test(comment)) {
      setError(t("p2p.review.invalid_comment"));
      return;
    }    

    setIsLoading(true);

    try {
      let response;
      if (initialReview) {
        response = await patchRequest(`/p2p_trades/reviews/${initialReview.id}`, {
          vote: vote,
          comment: comment,
        });
      } else {
        response = await postRequest('/p2p_trades/reviews', {
          profile_id: profileId,
          reviewed_profile_id: reviewedProfileId,
          trade_external_id: tradeExternalId,
          vote: vote,
          comment: comment,
        });
      }

      if (response) {
        setError(null);
        onSuccess();
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      setError(t("p2p.review.failed"));
    }

    setIsLoading(false);
  };

  return (
    <div>
      <span className="reviewform-title">{initialReview ? t("p2p.review.edit") : t("p2p.review.leave")}</span>
      {error && (
        <div className="reviewform-error" role="alert">
          {error}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="reviewform-subtitle">{t("p2p.review.rate_q")}</label>
          <span className='vote-btns'> 
            <button
                title={t("p2p.review.liked")}
                type="button"
                className={`reviewbtn ${vote === 'upvote' ? 'upvote-button' : 'default-button'} text-white mr-2`}
                onClick={() => handleVoteChange('upvote')}
            >
                <i className="fa fa-thumbs-up" aria-hidden="true"></i>
            </button>
            <button
                title={t("p2p.review.disliked")}
                type="button"
                className={`reviewbtn ${vote === 'downvote' ? 'downvote-button' : 'default-button'} text-white`}
                onClick={() => handleVoteChange('downvote')}
            >
                <i className="fa fa-thumbs-down" aria-hidden="true"></i>
            </button>

          </span>

        </div>
        <div className="mb-3">
          <label htmlFor="comment" className="reviewform-subtitle">
            {t("p2p.review.describe_q")}
          </label>
          <textarea
            className="review-textarea"
            id="comment"
            value={comment}
            onChange={handleCommentChange}
            rows="4"
          />
        </div>
        <button type="submit" className="review-submit-button" disabled={isLoading}>
          {isLoading ? t("p2p.review.submitting") : initialReview ? t("p2p.review.update") : t("p2p.review.submit")}
        </button>
      </form>
    </div>
  );
};

export default ReviewForm;
